import { vansiteMailContactEvent } from '../util/api';
import { logError } from '../util/log';

/**
 * Meldet dem Backend ein Kontakt-Ereignis (E-Mail verifiziert, Inserat
 * veröffentlicht, …). Fire-and-forget: ein Fehler wird geloggt, bricht aber
 * nie den Nutzerablauf - die Listenpflege ist Backend-Sache.
 *
 * @param {string} event
 */
export const notifyMailContactEvent = (event) => () => {
  return vansiteMailContactEvent({ event }).catch((e) => {
    logError(e, 'mail-contact-event', { event });
  });
};
